import { AsyncPipe, NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { HighlightModule } from 'ngx-highlightjs';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  standalone: true,
  imports: [HighlightModule, AsyncPipe, NgIf],
})
export class ProfileComponent implements OnInit {
  profileJson: string = null;

  constructor(public auth: AuthService, private http: HttpClient) { }

  ngOnInit() {
    this.auth.user$.subscribe(
      (profile) => (this.profileJson = JSON.stringify(profile, null, 2))
    );
    this.callFedExApi();
  }

  callFedExApi() {
    this.http.get(
      'https://wwwtest.fedex.com/secure-login/assets/configs/config.json',
      {
        withCredentials: true
      }

    ).subscribe(
      (response) => {
        // Handle successful response
        console.log(response);
      },
      (error) => {
        // Handle error
        console.error('Request failed', error);
      }
    );
  }
}
